<template>
  <div class="page-wrapper">

    <search-group title="结算单查询" @search="findData" @clear="clearValue">
      <Row :gutter="16" class="mb16">
        <Col span="6">
          <Select placeholder="项目名称" v-model="searchData.projectFid">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="账期类型" v-model="searchData.balancePeriodType">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in periodType" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="付款状态" v-model="searchData.paymentStatus">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in payStatus" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <!--<Input  class="block" v-model="searchData.condition" @keyup.enter.native="findData" placeholder="结算单号、付款单号、收款账号、业主名称"/>-->
          <Input  class="block" v-model="searchData.condition" @keyup.enter.native="findData" :placeholder="placeholderText"/>

        </Col>
      </Row>

    </search-group>
    <div class="flex mb16" >
      <!--<div>待业主确认:</div>-->
      <!--<div>待平台审核:</div>-->
      <!--<div>待结算:</div>-->
      <!--<div>已结算</div>-->
      <!--<div>驳回</div>-->
      <div v-for="item,index in  overReview" class="over-item">
        <span>{{item.balanceStatusStr}}:</span>
        <span class="text-red">{{item.paymentMoneyStr}}</span>
      </div>

    </div>
    <div >
      <RadioGroup type="button" v-model="searchData.balanceStatus" @on-change="changeStatus">
        <Radio v-for="(item,index) in balanceStatus" :label="item.value" :key="'keyH'+index">{{item.text}}</Radio>
      </RadioGroup>
    </div>

  </div>
</template>

<script>
  // import SearchGroup from 'components/SearchGroup/index';
  import {getProjects} from "../../../api/common";
  import {getBalanceListCondition} from "../../../api/settleManage";

  export default {
    // name: "SearchList",
    components: {
      // SearchGroup
    },
    props:{
      overReview:{
        type:Array,
        default:()=>{return []}
      }

    },
    data() {
      return {
        shortCut1: '',
        projectList: [],
        searchData: {
          projectFid: '',
          balancePeriodType: '',
          balanceStatus: 0,
          condition: '',
          paymentStatus: ''
        },
        periodType: [],
        payStatus: [],
        balanceStatus: [],

      }
    },
    computed:{
      placeholderText(){
        if(this.searchData.balanceStatus===2 || this.searchData.balanceStatus===3){
          return '结算单号、付款单号、收款账号、业主名称'
        }
        else {
          return '结算单号、收款账号、业主名称'
        }
      }
    },
    methods: {
      changeStatus() {
        this.$emit('findData', this.searchData)

      },
      getBalanceListCondition() {
        getBalanceListCondition().then(res => {
          if (!res.data) {
            return
          }
          this.periodType = res.data.periodType
          this.payStatus = res.data.payStatus
          this.balanceStatus = res.data.balanceStatus

        }).catch(error => {

        })
      },
      findData() {
        // if(!this.searchData.projectFid){
        //   this.$Message.info('请选择项目')
        //   return
        // }
        this.$emit('findData', this.searchData)
      },
      clearValue() {
        this.searchData.projectFid = ''
        this.searchData.balancePeriodType = ''
        this.searchData.condition = ''
        this.searchData.paymentStatus = ''
      }
    },
    created() {
      this.getBalanceListCondition()
      getProjects().then(res => {
        res.data && (this.projectList = res.data)
        // if(this.projectList.length){
        //   this.searchData.projectFid=this.projectList[0].value
        //   this.$emit('findData', this.searchData)
        //
        // }
      }).catch(error => {
      })
      this.$emit('findData', this.searchData)

    }
  }
</script>
<style scoped>
  .over-item{
    width: 180px;
  }


</style>
